<template>
  <div class="box">
    <br />
    <br />
    <div class="container" ref="container">
      <div class="models">
        <!-- <a-button
          style="padding: 0 8px; margin: 10px; background-color: #000334;"
          type="primary"
          v-show="unitShow"
          @click="changeComponent(3)"
        >关联站房</a-button> -->
        <a-button
          style="padding: 0 8px; margin: 10px; background-color: #000334;"
          type="primary"
          v-show="isButtonShow && !isFullScreen"
          @click="changeComponent(1)"
        >{{ $t('station.configuration') }}</a-button>
        <a-button style="padding: 0 8px; margin: 10px;" type="primary" v-show="!isFullScreen">{{ $t('station.data') }}</a-button>
        <h1>{{stationName}}</h1>
        <a-button
          :style="`position: absolute; right: ${ lang === 'en' ? 110 : 80 }px; margin: 10px`"
          icon="fullscreen"
          @click="setCache"
        >{{ $t('station.ds') }}</a-button>
        <a-button
          style="float: right; padding: 0 8px; margin: 10px"
          icon="fullscreen"
          @click="setFullscreen"
          :style="{ opacity: isFullScreen ? 0 : 1}"
        >{{ $t('buttons.fullscreen') }}</a-button>
      </div>
      <a-modal v-model="visible" :title="$t('station.ds')" @ok="changeDevices" :confirm-loading="confirmLoading" @cancel="setDeviceList">
        <div class="deviceHeader">
          <h3>{{ $t('station.LLJ') }}</h3>
        </div>
        <a-checkbox-group v-model="flowmeter">
          <a-checkbox
            v-for="item in flowmeterList"
            :key="item.code"
            :value="item.code"
          >{{item.name}}</a-checkbox>
        </a-checkbox-group>
        <div class="deviceHeader">
          <h3>{{ $t('station.DB') }}</h3>
        </div>
        <a-checkbox-group v-model="elctricityMeter">
          <a-checkbox
            v-for="item in elctricityMeterList"
            :key="item.code"
            :value="item.code"
          >{{item.name}}</a-checkbox>
        </a-checkbox-group>
      </a-modal>
      <div class="wrapper" ref="wrapper">
        <div class="row_top">
          <div class="col keywords">
            <div class="header">
              <img src="@/assets/header1.png" />
              <h3>{{ $t('station.key') }}</h3>
            </div>
            <div class="content">
              <div class="item">
                <h1 class="title">{{ $t('station.aGas') }}({{ unit }}/min)</h1>
                <div class="content-wrapper">
                  <div class="today">
                    <span class="data">{{dataList[1].avgGasConsumption || 0}}</span>
                    <span class="description">{{ $t('station.today') }}</span>
                  </div>
                  <div class="border"></div>
                  <div class="yesterday">
                    <span class="data">{{dataList[0].avgGasConsumption || 0}}</span>
                    <span class="description">{{ $t('station.yesterday') }}</span>
                  </div>
                </div>
              </div>
              <div class="item">
                <h1 class="title">{{ $t('station.gas') }}({{ unit }})</h1>
                <div class="content-wrapper">
                  <div class="today">
                    <span class="data">{{dataList[1].flowMeterAccumulation || 0}}</span>
                    <span class="description">{{ $t('station.today') }}</span>
                  </div>
                  <div class="border"></div>
                  <div class="yesterday">
                    <span class="data">{{dataList[0].flowMeterAccumulation || 0}}</span>
                    <span class="description">{{ $t('station.yesterday') }}</span>
                  </div>
                </div>
              </div>
              <div class="item">
                <h1 class="title">{{ $t('station.aPower') }}(kW)</h1>
                <div class="content-wrapper">
                  <div class="today">
                    <span class="data">{{dataList[1].avgPower || 0}}</span>
                    <span class="description">{{ $t('station.today') }}</span>
                  </div>
                  <div class="border"></div>
                  <div class="yesterday">
                    <span class="data">{{dataList[0].avgPower || 0}}</span>
                    <span class="description">{{ $t('station.yesterday') }}</span>
                  </div>
                </div>
              </div>
              <div class="item">
                <h1 class="title">{{ $t('station.power') }}(kW·H)</h1>
                <div class="content-wrapper">
                  <div class="today">
                    <span class="data">{{dataList[1].electricityMeterAccumulation || 0}}</span>
                    <span class="description">{{ $t('station.today') }}</span>
                  </div>
                  <div class="border"></div>
                  <div class="yesterday">
                    <span class="data">{{dataList[0].electricityMeterAccumulation || 0}}</span>
                    <span class="description">{{ $t('station.yesterday') }}</span>
                  </div>
                </div>
              </div>
              <div class="item">
                <h1 class="title">{{ $t('station.aPressure') }}(MPa)</h1>
                <div class="content-wrapper">
                  <div class="today">
                    <span class="data">{{dataList[1].avgPressure || 0}}</span>
                    <span class="description">{{ $t('station.today') }}</span>
                  </div>
                  <div class="border"></div>
                  <div class="yesterday">
                    <span class="data">{{dataList[0].avgPressure || 0}}</span>
                    <span class="description">{{ $t('station.yesterday') }}</span>
                  </div>
                </div>
              </div>
              <div class="item">
                <h1 class="title">{{ $t('station.ratioT') }}(kW·H/{{ unit }})</h1>
                <div class="content-wrapper">
                  <div class="today">
                    <span class="data">{{dataList[1].avgConsumption || 0}}</span>
                    <span class="description">{{ $t('station.today') }}</span>
                  </div>
                  <div class="border"></div>
                  <div class="yesterday">
                    <span class="data">{{dataList[0].avgConsumption || 0}}</span>
                    <span class="description">{{ $t('station.yesterday') }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="header">
              <img src="@/assets/header2.png" />
              <h3>{{ $t('station.ratioTO') }}</h3>
            </div>
            <div class="content">
              <div class="gauge"></div>
              <div class="analyse">
                <p class="description">
                  <span class="data">{{consumption1}}</span>
                  <span class="unit">{{ $t('station.today') }}</span>
                </p>
                <div class="border"></div>
                <p class="description">
                  <span class="data">{{consumption0}}</span>
                  <span class="unit">{{ $t('station.yesterday') }}</span>
                </p>
                <div class="border"></div>
                <p class="description">
                  <span class="data">{{-percent}}%</span>
                  <span class="unit">{{ $t('station.es') }}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="row_bottom">
          <div class="col">
            <div class="header">
              <img src="@/assets/header3.png" />
              <h3>{{ $t('station.ds') }}</h3>
            </div>
            <div class="device">
              <!-- <div class="empty">
                <img src="@/assets/empty.png" />
                <span>暂无数据</span>
              </div> -->
              <div class="d" :style="liStyle">
                <h3>{{ $t('station.LLJ') }}</h3>
                <div class="devicelist" :style="{ paddingTop: flowmeterList.length > 3 ? 'unset' : '8px', overflow: flowmeterList.length > 3 ? 'auto' : 'hidden' }">
                  <!-- <div style="height: 300px"></div> -->
                  <ul class="clearfix">
                    <li
                      v-for="item in flowmeterList"
                      :key="item.code"
                    >
                      <label
                        :for="item.code"
                        :title="item.name"
                      >
                        <span class="device_name">{{ item.name }}</span>
                        <input :id="item.code" type="checkbox" v-model="item.checked" @change="handleDeviceCheckedChange">
                        <div class="show-box"></div>
                      </label>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="d" :style="fLiStyle">
                <h3>{{ $t('station.DB') }}</h3>
                <div class="devicelist">
                  <!-- <div style="height: 300px"></div> -->
                  <ul class="clearfix">
                    <li
                      v-for="item in elctricityMeterList"
                      :key="item.code"
                    >
                      <label
                        :for="item.code"
                        :title="item.name"
                      >
                        <span class="device_name">{{ item.name }}</span>
                        <input :id="item.code" type="checkbox" v-model="item.checked" @change="handleDeviceCheckedChange">
                        <div class="show-box"></div>
                      </label>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="header">
              <img src="@/assets/header4.png" />
              <h3>{{ $t('station.cf') }}</h3>
            </div>
            <div class="content">
              <div class="data-wrapper">
                <span class="data">{{flow}}</span>
                <span class="unit">{{ unit }}/min</span>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="header">
              <img src="@/assets/header4.png" />
              <h3>{{ $t('station.cp') }}</h3>
            </div>
            <div class="content">
              <div class="data-wrapper">
                <span class="data">{{power}}</span>
                <span class="unit">kW</span>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="header">
              <img src="@/assets/header4.png" />
              <h3>{{ $t('station.cra') }}</h3>
            </div>
            <div class="content">
              <div class="data-wrapper">
                <span class="data">{{g}}</span>
                <span class="unit">kW·H/{{ unit }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { deviceApi } from "@/api/station";
import { websocketUrl } from "@/plugins/service";
import { getDeviceGroup, searchDeviceList, getDayReport } from "@/api/device";

export default {
  data() {
    return {
      isButtonShow: false,
      isFullScreen: false,
      stationName: "",
      flowmeterList: [],
      deviceList: [],
      elctricityMeterList: [],
      flowmeter: [],
      elctricityMeter: [],
      dataList: [{}, {}],
      consumption0: 0,
      consumption1: 0,
      flow: 0,
      power: 0,
      visible: false,
      confirmLoading: false,
      elctricityMeter: [],
      flowmeter: [],
      unitShow: false,
      unit: 'Nm³'
    };
  },
  props: {
    models: Array,
    changeComponent: Function
  },
  computed: {
    percent() {
      return +this.consumption0 === 0
        ? 0
        : ((this.consumption1 / this.consumption0 - 1) * 100).toFixed(2);
    },
    g() {
      console.log(this.power, this.flow);
      return this.flow === 0 ? 0 : (this.power / this.flow / 60).toFixed(5);
    },
    liStyle() {
      return this.flowmeterList.length > 3 ? { height: '49%' } : { height: '28%' }
    },
    fLiStyle() {
      return this.flowmeterList.length > 3 ? { height: '49%' } : { height: '72%' }
    },
    lang() {
      return this.$store.state.lang
    }
  },
  created() {
    this.isButtonShow = this.models.includes("1");
    this.deviceCodes = [];
    this.getCurrentDate();
  },
  beforeDestroy() {
    if (this.webSocket) {
      this.webSocket.close()
    }
  },
  mounted() {
    const el = this.$refs.container;
    const ratio = 1920 / 1080;
    let w =
      window.innerWidth - el.offsetLeft - 20 < 1200
        ? 1200
        : window.innerWidth - el.offsetLeft - 20;
    let h = Math.ceil(w / ratio) + 52;
    el.style.width = w + "px";
    el.style.height = h + "px";
    this.w = w;
    this.h = h;
    document.addEventListener("fullscreenchange", this.handleFullscreenchange);
    this.flexible();
  },
  methods: {
    setFullscreen() {
      this.$refs.container.requestFullscreen();
    },
    handleFullscreenchange() {
      const el = this.$refs.wrapper;
      const container = this.$refs.container;
      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer);
      }
      const isFullScreen = document.fullscreenElement !== null;
      this.isFullScreen = isFullScreen;
      this.resizeTimer = setTimeout(() => {
        if (el) {
          if (isFullScreen) {
            el.style.width = window.innerWidth + "px";
            console.log(+el.style.height.slice(0, -2) + 52);
            console.log(window.innerHeight);
            if ((window.innerWidth * 1080) / 1920 > window.innerHeight) {
              el.style.height =
                Math.ceil((window.innerWidth * 1080) / 1920) - 52 + "px";
              container.style.height = window.innerHeight + "px";
              container.style.overflowY = "auto";
              container.style.overflowX = "hidden";
            } else {
              el.style.height = (window.innerWidth * 1080) / 1920 - 52 + "px";
              container.style.overflowY = "unset";
              container.style.overflowX = "unset";
            }
            if (window.innerWidth < 1200) {
              const option = JSON.parse(JSON.stringify(this.option));
              const {
                axisLine,
                splitLine,
                axisTick,
                axisLabel,
                data
              } = option.series[0];
              axisLine.lineStyle.width = 6;
              axisTick.length = 14;
              axisTick.distance = -5;
              axisLabel.fontSize = 10;
              splitLine.length = 14;
              splitLine.distance = -5;
              data[0].detail.fontSize = 15;
              data[0].detail.offsetCenter = [0, "60%"];
              if (window.innerWidth < 900) {
                axisLabel.fontSize = 8;
                data[0].detail.fontSize = 12;
              }
              this.charts.setOption(option);
            }
          } else {
            el.style.width = this.w + "px";
            el.style.height = this.h - 52 + "px";
            container.style.height = this.h + "px";
            if (window.innerWidth < 1200) {
              this.charts.setOption(this.option);
            }
          }
        }
      }, 100);
    },
    flexible() {
      const docEl = document.documentElement;
      const dpr = window.devicePixelRatio || 1;
      this.setBodyFontSize(dpr);
      this.setRemUnit(docEl);
    },
    setBodyFontSize(dpr) {
      if (document.body) {
        document.body.style.fontSize = 12 * dpr + "px";
      } else {
        document.addEventListener(
          "DOMContentLoaded",
          this.setBodyFontSize(dpr)
        );
      }
    },
    setCache() {
      this.cacheflowCodes = [...this.flowmeter]
      this.cacheECodes = [...this.elctricityMeter]
      this.visible = true
    },
    setRemUnit(docEl, isFullScreen) {
      let rem;
      if (isFullScreen) {
        rem = docEl.clientWidth / 20;
      } else {
        rem = (docEl.clientWidth < 1440 ? 1440 : docEl.clientWidth) / 20;
      }
      docEl.style.fontSize = rem + "px";
    },
    async getDevices() {
      const { data } = await getDeviceGroup(this.$route.query.id);
      this.stationName = data.name;
      const chart = data.extraProperty || {
        charts: [],
        flow: "",
        model: [],
        pressure: "",
        stations: [],
        devicesList: []
      };
      this.unit = chart.unit || 'Nm³'
      this.unitShow = chart.stations?.length > 0;
      const deviceCodes = data?.extraProperty?.deviceCodes ? JSON.parse(data.extraProperty.deviceCodes) : []
      data.devices &&
        data.devices.forEach(device => {
          if (device.type === "LLJ") {
            // device.checked = true;
            this.flowmeterList.push(device);
            this.deviceList.push(device);
            if (deviceCodes.find(code => code === device.code)) {
              device.checked = true
              this.deviceCodes.push(device.code);
              this.flowmeter.push(device.code);
            }
          } else if (device.type === "DB") {
            // device.checked = true;
            this.elctricityMeterList.push(device);
            this.deviceList.push(device);
            if (deviceCodes.find(code => code === device.code)) {
              device.checked = true
              this.deviceCodes.push(device.code);
              this.elctricityMeter.push(device.code);
            }
          }
        });
      await this.getData();
      this.drawCharts();
      this.connectWebSocket();
      try {
      } catch {}
    },
    getCurrentDate() {
      console.log(1);
      const date = new Date();
      this.endDate = moment(+date).format("YYYY-MM-DD");
      this.startDate = moment(+date - 24 * 60 * 60 * 1000).format("YYYY-MM-DD");
      this.getDevices();
    },
    drawCharts() {
      this.charts = this.$echarts.init(document.querySelector(".gauge"), null, {
        render: "canvas",
        useDirtyRect: false
      });
      this.option = {
        series: [
          {
            type: "gauge",
            startAngle: 225,
            endAngle: -45,
            center: ["50%", "55%"],
            radius: "110%",
            // radius: '100%',
            min: 0,
            max: 0.3,
            splitNumber: 6,
            axisLine: {
              lineStyle: {
                // width: 10,
                width: 10,
                color: [
                  [0.166, "#4473ff"],
                  [0.332, "#3db54f"],
                  [0.498, "#ede969"],
                  [0.665, "#d36b43"],
                  [0.832, "#ce1712"],
                  [1, "#6b0100"]
                ]
              }
            },
            pointer: {
              itemStyle: {
                color: "inherit"
              }
            },
            axisTick: {
              length: 20,
              distance: -9,
              lineStyle: {
                color: "auto",
                width: 2
              }
            },
            splitLine: {
              distance: -9,
              length: 20,
              lineStyle: {
                color: "auto",
                width: 2
              }
            },
            axisLabel: {
              color: "#bbb",
              fontSize: 18
            },
            // detail: {
            //   valueAnimation: true,
            //   formatter: '{value}',
            //   color: 'inherit',
            //   fontSize: 20
            // },
            data: [
              {
                value: this.consumption1,
                detail: {
                  show: true,
                  color: "inherit",
                  fontSize: 24,
                  formatter(value) {
                    return value.toFixed(5);
                  }
                }
              }
            ]
          }
        ]
      };
      if (window.innerWidth < 1500) {
        this.option.series[0].data[0].detail.offsetCenter = [0, "70%"];
      }
      this.charts.setOption(this.option);
      window.addEventListener("resize", () => {
        setTimeout(() => {
          this.charts.resize();
        }, 300);
      });
    },
    connectWebSocket() {
      const authorization = 'Bearer ' + JSON.parse(localStorage.getItem('token'))
      this.webSocket = new WebSocket(
        `${websocketUrl}/group/${this.$route.query.id}?token=${authorization}`
      );
      this.webSocket.onopen = () => {
        this.webSocket.send(this.deviceCodes + '')
      }
      this.webSocket.onmessage = e => {
        const record = JSON.parse(e.data);
        if (!record.device_code) {
          this.power = record.power;
          this.flow = record.flow;
        }
      };
    },
    async getData() {
      if (this.deviceCodes.length > 0) {
        const { startDate, endDate, deviceCodes } = this;
        try {
          const t = await getDayReport(endDate, deviceCodes + "");
          const y = await getDayReport(startDate, deviceCodes + "");
          this.dataList = [y.data.at(-1), t.data.at(-1)];
          this.consumption0 = this.dataList[0].avgConsumption.toFixed(5);
          this.consumption1 = this.dataList[1].avgConsumption.toFixed(5);
        } catch {
          // this.$message.error("请求失败")
        }
      } else {
        this.$message.warning("暂无设备");
      }
    },
    async changeDevices() {
      this.confirmLoading = true;
      this.deviceCodes = this.flowmeter.concat(this.elctricityMeter);
      console.log(this.deviceCodes);
      try {
        await this.getData();
        this.webSocket.send(this.deviceCodes + "");
        this.charts.setOption({
          series: [
            {
              data: [
                {
                  value: this.consumption1,
                  detail: {
                    show: true,
                    color: "inherit",
                    fontSize: 20,
                    formatter(value) {
                      return value.toFixed(5);
                    }
                  }
                }
              ]
            }
          ]
        });
        this.visible = false;
        this.flowmeterList.forEach(f => {
          f.checked = false
          if (this.flowmeter.find(ff => ff === f.code)) {
            f.checked = true
          }
        })
        this.elctricityMeterList.forEach(f => {
          f.checked = false
          if (this.elctricityMeter.find(ff => ff === f.code)) {
            f.checked = true
          }
        })
      } catch {
        // this.$message.error("请求失败")
      } finally {
        this.confirmLoading = false;
      }
    },
    setDeviceList() {
      this.flowmeter = this.cacheflowCodes
      this.elctricityMeter = this.cacheECodes
    },
    handleDeviceCheckedChange() {
      this.flowmeter = []
      this.flowmeterList.forEach(f => {
        if (f.checked) {
          this.flowmeter.push(f.code)
        }
      })
      this.elctricityMeter = []
      this.elctricityMeterList.forEach(e => {
        if (e.checked) {
          this.elctricityMeter.push(e.code)
        }
      })
      this.changeDevices()
    }
  }
};
</script>

<style lang="less" scoped>
li {
  list-style: none;
}
.deviceHeader {
  width: 100%;
  padding: 10px 0 0;
  margin-bottom: 10px;
  overflow: hidden;
  border-bottom: 1px solid #ccc;
}
.container {
  &::-webkit-scrollbar {
    display: none;
  }
  margin-top: -52px;
  position: relative;
  .models {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    background: url('../../../../assets/bg-dark.jpg')
      0 0 / cover no-repeat;
    h1 {
      color: #fff;
      display: inline-block;
      font-size: 24px;
      margin-left: 20px;
    }
  }
  .wrapper {
    background: url('../../../../assets/bg-dark.jpg')
      0 0 / cover no-repeat;
    position: absolute;
    top: 52px;
    left: 0;
    right: 0;
    bottom: 0;
    [class^="row"] {
      width: 100%;
      height: 50%;
      display: flex;
      justify-content: space-between;
      .col {
        width: 49%;
        height: 100%;
        background: linear-gradient(
          180deg,
          rgba(6, 23, 55, 0.6),
          rgba(21, 27, 48, 0.8)
        );
        display: flex;
        flex-direction: column;
        .header {
          height: 12%;
          border-bottom: 1px solid hsla(0, 0%, 100%, 0.2);
          display: flex;
          align-items: center;
          position: relative;
          img {
            height: 90%;
            vertical-align: bottom;
          }
          h3 {
            color: #fff;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            left: 48px;
            font-size: .25rem;
          }
        }
        .content {
          flex: 1;
          padding: 16px;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          align-items: center;
        }
      }
    }
    .row_top {
      .col .content {
        .item {
          width: 49%;
          height: 30%;
          display: flex;
          flex-direction: column;
          background: linear-gradient(
            90deg,
            rgba(32, 34, 41, 0.9),
            rgba(28, 35, 42, 0.8)
          );
          border: 1px solid hsla(0, 0%, 100%, 0.1);
          &:hover {
            background: linear-gradient(
              180deg,
              rgba(32, 34, 41, 0.9),
              rgba(51, 145, 238, 0.8)
            );
            border: 1px solid rgba(93, 233, 219, 0.7);
          }
          .title {
            font-size: .2083rem;
            color: hsla(0, 0%, 100%, 0.75);
            margin: 4px;
          }
          .content-wrapper {
            flex: 1;
            display: flex;
            align-items: center;
            div {
              width: 50%;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: space-around;
              .data {
                color: #43c8e4;
                font-size: .2292rem;
              }
              @media screen and (max-width: 1024px) {
                :-webkit-full-screen .data {
                  font-size: 0.1875rem;
                }
              }
              .description {
                color: hsla(0, 0%, 100%, 0.45);
                font-size: .1875rem;
              }
              &.yesterday .data {
                color: #eda800;
              }
              &.border {
                width: 1px;
                height: 60%;
                background-color: #fff;
                opacity: 0.2;
                margin-top: 2%;
              }
            }
          }
        }
        .gauge {
          width: 100%;
          height: 70%;
        }
        .analyse {
          width: 60%;
          height: 20%;
          margin: 0 auto;
          display: flex;
          justify-content: space-between;
          .description {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;
            .data {
              color: #00adff;
              font-size: .2917rem;
              font-weight: 700;
            }
            .unit {
              color: #afbcc4;
              font-size: .2083rem;
            }
          }
        }
      }
    }
    .row_bottom {
      width: 100%;
      padding-top: 20px;
      .col {
        width: 20%;
        .content {
          justify-content: center;
          .weather {
            display: flex;
            flex-direction: column;
            align-items: center;
            img {
              margin-bottom: 70%;
            }
            .data {
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              align-items: center;
              .type {
                font-size: 0.1667rem;
                color: hsla(0, 0%, 100%, 0.75);
              }
              .detail {
                font-size: 0.25rem;
                color: #5fbeff;
                margin-top: 50%;
                span {
                  font-size: 0.1667rem;
                }
              }
            }
          }
        }
        .data-wrapper {
          display: flex;
          flex-direction: column;
          align-items: center;
          .data {
            font-size: 0.5208rem;
            color: #00eaff;
          }
          .unit {
            font-size: 0.2083rem;
            color: #00fff6;
          }
        }
      }
      .col:first-child {
        width: 36%;
        .empty {
          display: flex;
          flex-direction: column;
          align-items: center;
          span {
            margin-top: 30%;
            font-size: 0.1667rem;
            color: hsla(0, 0%, 100%, 0.6);
          }
        }
      }
      .col:nth-child(2),
      .col:nth-child(3),
      .col:nth-child(4) {
        .content {
          background-image: url("../../../../assets/bg1.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }
      }
    }
  }
}
.device {
  width: 100%;
  height: 88%;
  padding: 0 10px;
  // background-color: skyblue;
  // overflow: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .d {
    height: 49%;
    display: flex;
    flex-direction: column;
    h3 {
      // background-color: pink;
      margin-bottom: 0;
      font-size: .2292rem;
      color: hsla(0, 0%, 100%, 0.75);
    }
    .devicelist {
      flex: 1;
      overflow: auto;
      // display: flex;
      // align-items: center;s
      &::-webkit-scrollbar {
        width: 8px;
        border-radius: 4px;
      }
      &::-webkit-scrollbar-track {
        width: 8px;
        border-radius: 4px;
      }
      &::-webkit-scrollbar-thumb {
        width: 8px;
        background-color: #4961a3;
        border-radius: 4px;
      }
      ul {
        // display: flex;
        // justify-content: space-between;
        // flex-wrap: wrap;
        width: 100%;
        padding: 10px;
        overflow: hidden;
      }
      .clearfix::after {
        content: "";
        display: table;
        clear: both;
      }
      li {
        width: 31%;
        float: left;
        margin-left: 10px;
      }
      label {
        color: #fff;
        width: 100%;
        // background-color: skyblue;
        margin-bottom: 15px;
        padding: 5px 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: relative;
        border: 1px solid rgb(164, 216, 255);
        border-radius: 10px;
        box-shadow: -1px -1px 6px 2px rgba(164, 216, 255, 1) inset;
        color: rgb(164, 216, 255);
        text-align: center;
        font-size: .2083rem;
        cursor: pointer;
        .device_name {
          width: calc(100% - 21px);
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          padding-right: 5px;
        }
        input:checked + .show-box {
          background-color: #0075ff;
        }
        .show-box {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: 10px;
          width: 20px;
          height: 20px;
          border-radius: 3px;
          // border: 1px solid #d8d8d8;
          background-color: white;
        }
        .show-box::before {
          content: '';
          position: absolute;
          top: 4px;
          left: 7px;
          width: 7px;
          height: 10px;
          border: solid white;
          border-width: 0 2px 2px 0;
          transform: rotate(45deg);
        }
        input {
          position: absolute;
          background-color: transparent;
          top: 50%;
          transform: translateY(-50%);
          right: 10px;
          opacity: 0;
          z-index: 10;
          margin: 0;
          width: 21px;
          height: 21px;
          outline: none;
          border: none;
          cursor: pointer;
        }
      }
    }
  }
}
@media screen and (max-width: 1440px) {
  .box {
    overflow-x: auto;
  }
}
@media screen and(max-width: 1420px) {
  :-webkit-full-screen .container .wrapper .row_top .col .content .gauge {
    height: 62%;
  }
}
@media screen and (max-width: 1240px) {
  :-webkit-full-screen .keywords .content {
    padding: 8px !important;
    .item {
      height: 31% !important;
    }
  }
  :-webkit-full-screen .keywords .content .item {
    .title,
    .data,
    .description {
      font-size: 12px !important;
    }
  }
}
@media screen and (max-width: 860px) {
  :-webkit-full-screen .analyse {
    margin-top: -20px !important;
  }
  :-webkit-full-screen .header h3 {
    font-size: 12px !important;
  }
  :-webkit-full-screen .keywords .content {
    transform: scaleY(0.8) translateY(-26px) !important;
    .item {
      height: 36% !important;
      transform: scaleY(0.7);
    }
  }
}
</style>
